import React, { useEffect, useMemo, useState } from "react";
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { ApprovedSimulators, ClockIconSimulators } from "~misc/icons";
import ProdutoItem from "./ProdutoItem";
import { db } from "~db/db";
import usePrazoRegraSimuladores from "~fetchs/usePrazoRegraSimuladores";

const CardGrupoProduto = ({ groupProduct, cliente, simulador, indexGP, hierarquiasAprovacaoMaxima }) => {
  const familiasIds = groupProduct?.produtos
  .map((produto) => produto.produtoOriginal?.familiaId)
  .filter((id) => !!id);


  const { prazoRegras } = usePrazoRegraSimuladores({
    gruposegmento: cliente?.grupoSegmentoId,
    familias: familiasIds
  });
  const searchDias = (familiaId, prazoRegras) => {
    const prazoRegra = prazoRegras.find((regra) =>
      regra.familias.some((familia) => familia.id === familiaId)
    );
    return prazoRegra ? `${prazoRegra.dias } dias`: '-';
  };
  const getProductsGroupName = groupProduct.grupoProduto;
  const getProductsGroupStatus = groupProduct.status;
  const groupAprovador = useMemo(() => {
    if (hierarquiasAprovacaoMaxima != undefined)
      return hierarquiasAprovacaoMaxima.find(
        (aprovador) =>
          (aprovador.grupoProdutoId ?? aprovador.grupoMaterialId) ==
          (groupProduct.grupoProdutoId ?? groupProduct.grupoMaterialId)
      );
  }, [hierarquiasAprovacaoMaxima, groupProduct]);

  const statusTypes = {
    1: "não enviada",
    2: "pendente",
    3: "aprovada",
    4: "rejeitada"
  };

  function montaStatus() {
    const isCondicaoEspecial = groupProduct.produtos.some(produto => produto.condicao === "Condição Especial");
    const isFaixa = groupProduct.produtos.some(produto => produto.condicao === "Faixa");

    const tipoCondicaoGrupo = isCondicaoEspecial ? "Condição especial" : (isFaixa ? "Faixa" : "Mantem no regra");
    const status = (getProductsGroupStatus in statusTypes ? statusTypes[getProductsGroupStatus] : 'status não encontrado');

    return `${tipoCondicaoGrupo} ${(isCondicaoEspecial || isFaixa) ? status : ''}`;
  }
  const [prazoPagamentos, setPrazoPagamentos] = useState([]);
  useEffect(() => {
    const fetchPrazoPagamentos = async () => {
      const result = await db.prazoPagamento.filter((a) => a.ativo).toArray();
      setPrazoPagamentos(result);
    };

    fetchPrazoPagamentos();
  }, []);

  return (
    <>
      <AccordionItem className="rounded-lg overflow-hidden mb-4 !border-terciaria border">
        <AccordionButton className="bg-terciaria hover:!bg-terciaria text-white">
          <Box as="span" flex="1" textAlign="left" p={4}>
            <Text fontSize="2xl" fontWeight="bold" display="flex" justifyContent="space-between">
              {getProductsGroupName}
              <Box display="flex" alignItems="center">
                <Text display="flex" alignItems="center" gap="2" fontSize="lg">
                  {getProductsGroupStatus === 3 ? (<ApprovedSimulators />) : (<ClockIconSimulators />)}
                  {montaStatus()}
                  &ensp;{"-"}
                </Text>
                {groupAprovador && (
                  <Text fontWeight="normal" fontSize="md">
                    &ensp;{"Aprovador: " + groupAprovador?.hierarquia?.nome}
                  </Text>
                )}
              </Box>
            </Text>
          </Box>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel p={2} pb={4}>
          <TableContainer className="rounded-lg simulators__table">
            <Table>
              <Thead bg="#E6E6EE">
                <Tr>
                  <Th className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal">Material</Th>
                  <Th className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal">Centro</Th>
                  <Th className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal">Quantidade (Unidades)</Th>
                  <Th textAlign={"center"} className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal">Preço Final FOB</Th>
                  <Th textAlign={"center"} className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal">Preço Final CIF</Th>
                  <Th className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal">Prazo de Pagamento</Th>
                  <Th className="!text-primaria !normal-case !font-bold !whitespace-normal !tracking-normal"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {groupProduct?.produtos?.length > 0 &&
                  groupProduct?.produtos?.map((product, index) => {
                    const pzPagamento = prazoPagamentos.find((p) => p.id === product.prazoPagamentoId);
                    const pzRegra = searchDias(product?.produtoOriginal?.familiaId, prazoRegras)
                    return(
                        <ProdutoItem product={product} simulador={simulador} indexGP={indexGP} index={index} key={index}  prazoPagamento={pzPagamento?.nome} prazoRegra={pzRegra} />
                    )
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        </AccordionPanel>
      </AccordionItem>
    </>
  );
};

export default CardGrupoProduto;
